import { render, staticRenderFns } from "./NewFormConsent.vue?vue&type=template&id=1de83f5c&"
import script from "./NewFormConsent.vue?vue&type=script&lang=js&"
export * from "./NewFormConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports